<template>
  <div>
    <v-btn
      @click="onClick"
      :disabled="insertionOrder.isOverBudgetLimit"
      color="primary"
    >
      <v-icon>add</v-icon>予算を追加
    </v-btn>
    <AppModalEdit
      v-model="modalVisible"
      @clickExec="onSubmit"
      @cancel="close"
      :isExecButtonDisabled="!isValid && showValidationError"
      :actionsShadow="true"
      title="予算の追加申請"
      exec-button-text="申請"
      cancel-button-text="キャンセル"
      help-page-title="案件設定 ヘルプはこちら"
      help-page-url="https://go.geologic.co.jp/adminmanual_insertion_order"
    >
      <BulkAddBudgetForm
        ref="form"
        v-if="modalVisible"
        :insertionOrder="insertionOrder"
        :curerncy="advertiser.currency"
        :budget="budget"
        :budget-list="budgetList"
        :showValidationError="showValidationError"
        :onChangeShowValidationError="onChangeShowValidationError"
        @success="onSuccess"
        @onValidate="onValidate"
        @addBudget="$emit('addBudget', $event)"
      />
    </AppModalEdit>
  </div>
</template>

<script>
import { IOBudgetModel } from '@/models/IOBudget'
import BulkAddBudgetForm from '../Form/BulkAddBudgetForm'

export default {
  name: 'AddBudgetButton',
  components: { BulkAddBudgetForm },
  props: {
    insertionOrder: { type: Object, required: true },
    advertiser: { type: Object, required: true },
    budgetList: {
      type: Array,
      required: true,
    },
    isUpperBudgetLimit: { type: Boolean, required: true },
  },
  data() {
    return {
      modalVisible: false,
      budget: null,
      isValid: false,
      showValidationError: false,
    }
  },
  methods: {
    async onAddBudget() {
      await this.$confirm('予算の追加申請', {
        okText: '申請',
        cancelText: 'キャンセル',
        body: '予算の追加申請を行います。よろしいですか？',
      })
    },
    async onClick() {
      if (this.isUpperBudgetLimit) {
        const statusError = await this.$confirm('案件予算上限エラー', {
          okText: '閉じる',
          onlyOk: true,
          body: `設定されている案件予算数が上限の52に達しているため、新たに案件予算を追加できません。
          新たに案件予算を追加する場合は、新規案件を作成してください。`,
        })
        if (statusError) return
      }
      this.budget = new IOBudgetModel({
        insertionOrderId: this.insertionOrder.id,
      })
      this.modalVisible = true
    },
    async onSubmit() {
      if (!this.isValid) {
        this.showValidationError = true
      }

      this.$refs.form.submit()
    },
    onSuccess() {
      this.close()
    },
    close() {
      this.modalVisible = false
      this.showValidationError = false
    },
    onChangeShowValidationError(showValidationError) {
      this.showValidationError = showValidationError
    },
    onValidate(validity) {
      this.isValid = validity
    },
  },
}
</script>
